import { NodeId } from '../directives/if-node-directive/if-node-hide.directive';
import { LoginCountry } from './login-country.model';

export class Constants {
  // ROLES
  public static readonly ROLE_SECRETARY = 'Secretaria';
  public static readonly ROLE_SECRETARY_2 = 'Secretaria/Recepción';
  public static readonly ROLE_ADMINISTRATOR = 'Administrativa';
  public static readonly ROLE_ADMINISTRATOR_2 = 'Administración';
  public static readonly ROLE_MANAGER = 'Manager';
  public static readonly ROLE_BROKER = 'Broker';

  // AUTHORIZATION
  public static readonly USER_ROLES_ALL = '*';
  public static readonly USER_ROLES_STAFF = 'staff';
  public static readonly USER_ROLES_BROKER = 'broker';
  public static readonly USER_ROLES_REGIONAL = 'regional';
  public static readonly USER_ROLES_AGENT = 'agent';
  public static readonly USER_ROLES_PUBLIC = 'public';

  // TENANT IDs
  public static readonly TENANT_ID_AR: NodeId = 'ar';
  public static readonly TENANT_ID_EC: NodeId = 'ec';
  public static readonly TENANT_ID_UY: NodeId = 'uy';
  public static readonly TENANT_ID_PY: NodeId = 'py';
  public static readonly TENANT_ID_DO: NodeId = 'do';
  public static readonly TENANT_ID_GLOBAL: NodeId = 'global';
  public static readonly TENANT_ID_BO: NodeId = 'bo';

  // PAISES DEL SELECTOR DEL LOGIN
  // El listado es el mismo para todos los deploys: el login muestra como pais
  // actual el que comparte node con el deploy (mas los que comparten su misma
  // url, ej. Argentina y Uruguay) y ofrece el resto en el selector.
  // Se actualiza aca, no en cada environment.
  public static readonly LOGIN_COUNTRIES_DEV: LoginCountry[] = [
    {
      country: 'Argentina',
      node: Constants.TENANT_ID_AR,
      url: 'https://gestion-ar-v2.develop-redremax.com/login',
      flag: 'assets/images/flag-icons-main/ar.svg',
    },
    {
      country: 'Bolivia',
      node: Constants.TENANT_ID_BO,
      url: 'https://remaxbo-develop.herokuapp.com/login',
      flag: 'assets/images/flag-icons-main/bo.svg',
    },
    {
      country: 'Ecuador',
      node: Constants.TENANT_ID_EC,
      url: 'https://gestion-ec-v2.develop-redremax.com/login',
      flag: 'assets/images/flag-icons-main/ec.svg',
    },
    {
      country: 'Global',
      node: Constants.TENANT_ID_GLOBAL,
      url: 'https://gestion-global-v2.develop-redremax.com/login',
      flag: 'assets/images/flag-icons-main/globe.svg',
    },
    {
      country: 'Paraguay',
      node: Constants.TENANT_ID_PY,
      url: 'https://gestion-py-v2.develop-redremax.com/login',
      flag: 'assets/images/flag-icons-main/py.svg',
    },
    {
      country: 'República Dominicana',
      node: Constants.TENANT_ID_DO,
      url: 'https://gestion-do-v2.develop-redremax.com/login',
      flag: 'assets/images/flag-icons-main/do.svg',
    },
    {
      country: 'Uruguay',
      node: Constants.TENANT_ID_UY,
      url: 'https://gestion-ar-v2.develop-redremax.com/login',
      flag: 'assets/images/flag-icons-main/uy.svg',
    },
  ];

  public static readonly LOGIN_COUNTRIES_PROD: LoginCountry[] = [
    {
      country: 'Argentina',
      node: Constants.TENANT_ID_AR,
      url: 'https://gestion-ar-v2.qrsolutions.com.ar/login',
      flag: 'assets/images/flag-icons-main/ar.svg',
    },
    {
      country: 'Bolivia',
      node: Constants.TENANT_ID_BO,
      url: 'https://remaxbo-prod.herokuapp.com/logout',
      flag: 'assets/images/flag-icons-main/bo.svg',
    },
    {
      country: 'Ecuador',
      node: Constants.TENANT_ID_EC,
      url: 'https://gestion-ec-v2.qrsolutions.com.ar/login',
      flag: 'assets/images/flag-icons-main/ec.svg',
    },
    {
      country: 'Global',
      node: Constants.TENANT_ID_GLOBAL,
      url: 'https://gestion-global.qrsolutions.com.ar/logout',
      flag: 'assets/images/flag-icons-main/globe.svg',
    },
    {
      country: 'Paraguay',
      node: Constants.TENANT_ID_PY,
      url: 'https://gestion-py-v2.qrsolutions.com.ar/login',
      flag: 'assets/images/flag-icons-main/py.svg',
    },
    {
      country: 'República Dominicana',
      node: Constants.TENANT_ID_DO,
      url: 'https://gestion-do-v2.qrsolutions.com.ar/login',
      flag: 'assets/images/flag-icons-main/do.svg',
    },
    {
      country: 'Uruguay',
      node: Constants.TENANT_ID_UY,
      url: 'https://gestion-ar-v2.qrsolutions.com.ar/login',
      flag: 'assets/images/flag-icons-main/uy.svg',
    },
  ];

  /**
   * Nodes that use the Angular "Gastos y Rentabilidad" screen (/reports).
   * Any node not listed here is still sent to the legacy Reportes screen.
   * A node can only be added once its backend exposes the V2 endpoints.
   */
  public static readonly EXPENSES_AND_PROFIT_NODES: NodeId[] = [
    Constants.TENANT_ID_AR,
    Constants.TENANT_ID_EC,
  ];

  /** First selectable year in "Gastos y Rentabilidad" for nodes without a launch year. */
  public static readonly EXPENSES_AND_PROFIT_DEFAULT_FIRST_YEAR = 2019;

  /**
   * Nodes launched after the default range have no data before their launch year,
   * so earlier years are neither listed nor offered for comparison.
   */
  public static readonly EXPENSES_AND_PROFIT_LAUNCH_YEAR: Partial<
    Record<NodeId, number>
  > = {
    [Constants.TENANT_ID_DO]: 2026,
  };

  // SUPPORT
  public static readonly URL_SUPPORT_CHAT = 'https://central.chat/qrsolutions';

  // MONEDAS
  public static readonly INTERNATIONAL_CURRENCY = 'U$S';
  public static readonly LOCAL_CURRENCY = 'Local';
  public static readonly LOCAL_CURRENCY_SIMBOL = '$';
  public static readonly CURRENCY_DOLLAR = 'USD';
  public static readonly CURRENCY_PESOS_ARS = 'ARS';
  public static readonly CURRENCY_PESOS_UYU = 'UYU';
  public static readonly CURRENCY_PESOS_PYG = 'PYG';
  public static readonly CURRENCY_SYMBOL_PYG = '₲';

  // ICONOS
  public static readonly ICONS: any = {
    PLUS: 'plus',
    FILTER: 'filter',
    EQUAL: 'equal',
    ARROW_DROP_DOWN: 'arrow-drop-down',
    ARROW_DROP_UP: 'arrow-drop-up',
    EXPAND_MORE: 'expand-more',
    EXPAND_LESS: 'expand-less',
    DASHBOARD: 'dashboard',
    TIMELINE: 'timeline',
    TUNE: 'tune',
    PERSONS: 'persons',
    RESTART: 'restart-icon',
    SWAP_HORIZ: 'swap-horiz',
    BANK: 'bank',
    ASSIGNMENT: 'assignment',
    ANALYTICS: 'analytics',
    DESCRIPTION: 'description',
    ACCOUNT_CIRCLE: 'account-circle',
    SETTINGS: 'settings',
    PASSWORD: 'password',
    SUPPORT: 'support',
    SUPPORT_AGENT: 'support-agent',
    LOGOUT: 'logout',
    KEBAB: 'more-vert',
    LOCATION: 'location',
    PROPERTIES: 'properties',
    CALENDAR_ACCOUNT: 'calendar-account',
    CALENDAR_WORK: 'calendar-work',
    NEW_PROPERTIES: 'new-properties',
    TRENDING_UP: 'trending-up',
    TRENDING_DOWN: 'trending-down',
    CLOSE: 'close',
    ERROR: 'error',
    QUESTION: 'question-mark',
    ARROW_BACK: 'arrow-back',
    ARROW_LEFT: 'arrow_left',
    ARROW_RIGHT: 'arrow_right',
    ARROW_RIGHT_FULL: 'arrow-right-full',
    FIRST_PAGE: 'first_page',
    LAST_PAGE: 'last_page',
    TABLE_CHART: 'table-chart',
    AGENT: 'agent',
    COMISIONES_COBRADAS: 'comisiones-cobradas',
    DOWNLOAD: 'download',
    CALENDAR_EVENT: 'calendar-event',
    ARROW_FIRST_PAGE: 'first-page',
    ARROW_LAST_PAGE: 'last-page',
    DELETE: 'delete',
    SOLICITATE_CAE: 'solicitate-cae',
    DOWNLOAD_2: 'download-2',
    RELOAD: 'reload',
    SEND_EMAIL: 'send-email',
    CHECK: 'check',
    ALERT_ORANGE: 'alert-orange',
    CHECK_GREEN: 'check-green',
    WAITING_BLUE: 'waiting-blue',
    PENDING_YELLOW: 'pending-yellow',
    PENCIL_BLUE: 'pencil',
    SAVE: 'save',
    CALENDAR_VIEW: 'calendar-view',
    ARROW_NORTH: 'arrow-north',
    ARROW_SOUTH: 'arrow-south',
    DOCUMENT: 'document',
    SEARCH: 'search',
    AGENT_ADD: 'agent-add',
    AGENT_REMOVE: 'agent-remove',
    CHART: 'chart',
    WHATSAPP: 'whatsapp',
    EMAIL: 'email',
    CREDENTIAL: 'credential',
    CAKE: 'cake',
    CANCEL: 'cancel',
    INFO: 'info',
    ADD_PHOTO: 'add-photo',
    LEADER: 'leader',
    TRASH: 'trash',
    PICTURE: 'picture',
    AGENT_OFF: 'agent_off',
    WARNING: 'warning',
    APPLICATION_IMPORT: 'application-import',
    OUTGOING_EMAIL: 'outgoing-mail',
    SUMMARIZE: 'summarize',
    BAR_CHART: 'bar-chart',
    TROPHY: 'trophy',
    FILE_CHECK: 'file-check',
    AGENT_UP: 'agent-up',
    AGENT_DOWN: 'agent-down',
    LOCATION_2: 'location_2',
    CHECK_2: 'check_2',
    RENDITIONS_BETA: 'renditions-beta',
    PRINT: 'print',
    ADD_QUOTA: 'add_quota',
    DELETE_2: 'delete_2',
    EYE_OPEN: 'eye_open',
    MAGIC_WAND: 'magic_wand',
    INPUT: 'input',
    OUTPUT: 'output',
    SPLIT: 'split',
    MONEY: 'money',
    REAL_ESTATE: 'real-estate',
    LOCK_OPEN: 'lock-open',
    LOCK_CLOSED: 'lock-closed',
    STAR: 'star',
    CHAT: 'chat',
    ATTACH_FILE: 'attach-file',
    NOTIFICATION: 'notifications',
    NOTIFICATION_ACTIVE: 'notifications-active',
    PERSON_REJECTED: 'person-rejected',
    GROUP_OF_PEOPLE: 'group-of-people',
    EXPORT_FILES: 'export-files',
    STAR_HALF: 'star-half',
    CALL: 'call',
    PHONE: 'phone',
    ID_CARD: 'id-card',
    LINKEDIN: 'linkedin',
    FACEBOOK: 'facebook',
    INSTAGRAM: 'instagram',
    OFFICE: 'office',
    STAR_FILLED: 'star-filled',
    RECRUITMENT_MENU: 'recruitment',
    AGENT_CARD: 'agent-card',
    BILLED: 'facturado',
    PROFIT: 'rentabilidad',
    NET_RESULT: 'resultado-neto',
    DASH: 'dash-icon',
    EXPENSES: 'gastos-operativos',
    PLUS_2: 'plus-icon',
    AGENT_IN: 'ingreso-agente',
    PAYED_COMITIONS: 'comisiones-pagadas',
    RESULT_SELL: 'resultado-ventas',
    VARIABLE_EXPENSES: 'gastos-variables',
    COMITIONS_EARNED: 'comisiones-cobradas',
    PROPERTY_MANAGER: 'property_manager',
    HANDS: 'hands',
    CLOSED_LISTING: 'rendition',
    UPLOAD_FILE: 'upload-file',
    HOME: 'home',
    QR_LEARNING: 'qrlearning',
    SEARCH_ADVANCED: 'search_advance',
    CHANGE_CURRENCY: 'change_currency',
    CALENDAR_CHECK: 'calendar-check',
    HOME_RELOAD: 'home_reload',
    CLOCK: 'clock',
    HEART: 'heart',
    GENDER: 'gender',
    LOCK: 'lock',
    BUG_REPORT: 'bug-report',
    RELOAD_PAY: 'reload_pay',
    CANCEL_ACCOUNT: 'cancel_account',
    CANCEL_CALENDAR: 'calendar_cancel',
    ACTIVATE_ACOUNT: 'activate_account',
    ADD_PAYMENT: 'add_payment',
    ADD_EXPENSE: 'add_expense',
    ADD_NOTE: 'note_add',
    LIST: 'list',
    RESERVOMETRO: 'reservometro',
    OFFICES: 'offices',
    MAIN_DASH: 'maindash',
    FILE_ERROR: 'file_error',
    DRIVE_ADD: 'drive_add',
    ZIP: 'zip',
    TIME: 'time',
    VISIBILITY_OFF: 'visibility_off',
    SYNC: 'sync',
    TOOLS: 'tools',
    RANKING: 'ranking',
    OBJECTIVE: 'objective',
    FLAG: 'flag',
    ADD_NOTE_2: 'note-add',
    REGISTER: 'register',
    TARGET: 'target',
    INVENTORY: 'inventory',
    PEOPLE: 'people',
    CALENDAR: 'calendar',
    HOUSE_CHECK: 'house-check',
    WORKFLOW: 'workflow',
    TRANSFER: 'transfer',
    CALENDAR_OUTLINE: 'calendar-outline',
    PENDINGS: 'pendings',
    SOLID_TABLE: 'solid-table',
    NEGATIVE: 'negative',
    TEAM: 'team',
    TROPHY_EMPTY: 'trophy-empty',
    AGENTS_GROUP: 'agents-group',
    PRINT_ROUNDED: 'print-rounded',
    AI: 'ai',
    ANALYSIS: 'analisis',
    REPORTS: 'reportes',
    USB: 'usb',
    EXPAND_EXPENSES: 'expand_expenses',
    CONTRACT_EXPENSES: 'contract_expenses',
    DESK_PAYMENTS: 'desk-payments',
    CALCULATOR: 'calculator',
    USER_CHECK: 'user-check',
    ARROW_ROUND_RIGHT: 'arrow-round-right',
    ARROW_RIGHT_UP: 'arrow-right-up',
    PERCENT: 'percent',
  };
}
